import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";

import Stars from '../../../Common/Stars';
import { LoadingIcon } from '../../../Common/Loading_Icon';

import { setProfileDb } from '../../../../Actions/dataActions';
import { setList } from '../../../../Actions/stakeholderActions';

import Select from 'react-select';
import { Trans } from 'react-i18next';


class InviteOverlay extends Component {
    constructor(props) {    
        super(props);

        this.submitInvite = debounce(this.submitInvite.bind(this), 500);
        this.updateInviteForm = this.updateInviteForm.bind(this);
        this.loadDivisions = this.loadDivisions.bind(this);
        this.loadVMHs = this.loadVMHs.bind(this);
        this.loadOccupations = this.loadOccupations.bind(this);
        this.getStarValue = this.getStarValue.bind(this);
        this.updateOEM = this.updateOEM.bind(this);
        this.updateDivision = this.updateDivision.bind(this);
        this.updateVMH = this.updateVMH.bind(this);
        this.updateOccupation = this.updateOccupation.bind(this);
        this.updateLanguage = this.updateLanguage.bind(this);

        this.state = {
            invite_details: {},
            form_details: {},
            loaded_invite: true,
            edit: false,
            invite_form: {first_name: "", last_name: "", email: "", star: 3, invite_oem_id: null, invite_sh_id: null, invite_vmh_id: null, invite_occupation_id: null, language: "English"},
            selectedOEM: null, selectedDivision: null, selectedVMH: null, selectedOccupation: {label: "Regular User", value: null}
        };

        //
    }

    componentDidMount() {
         if (this.props.match.params.invite_id !== "new") {
            if (this.props.match.params.invite_id in this.props.data.invite_db) {
                this.setState({
                    invite_details: {"invite": this.props.data.invite_db[this.props.match.params.invite_id]},
                    loaded_invite: false
                })
            }
    
            var self = this;
            axios.get('/ajax/invitation/' + this.props.match.params.invite_id)
            .then(function(response) {
                self.setState({
                    invite_details: response?.data,
                    loaded_invite: false
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        }
        else {
             axios.get('/ajax/invitation/create')
            .then((response) => {

                if(response?.data.view.sh_id == -9 && response?.data.view.divisions.length == 1)
                {
                    this.loadVMHs(response?.data.view.divisions[0].SH_ID);
                    this.loadOccupations(response?.data.view.divisions[0].SH_ID);
                    this.state.invite_form.invite_sh_id = response?.data.view.divisions[0].SH_ID;
                }

                if(response?.data.view.vmh_id == -9 && response?.data.view.vmhs.length == 1)
                {
                    this.loadOccupations(response?.data.view.sh_id);
                    this.state.invite_form.invite_vmh_id = response?.data.view.vmhs[0].value;
                }

                if(response?.data.view.oem_id != -9) 
                {
                    this.state.invite_form.invite_oem_id = response?.data.view.oem_id;
                }

                if(response?.data.view.sh_id != -9)
                {
                    this.state.invite_form.invite_sh_id = response?.data.view.sh_id;
                }
                else if(response?.data.view.divisions.length > 0) 
                {
                    this.state.invite_form.invite_sh_id = response?.data.view.divisions[0].value
                }

                if(response?.data.view.vmh_id != -9)
                {
                    this.state.invite_form.invite_vmh_id = response?.data.view.vmh_id;
                } 
                else if(response?.data.view.vmhs.length > 0) 
                {
                    this.state.invite_form.invite_vmh_id = response?.data.view.vmhs[0].value
                }

                this.setState({
                    form_details: response?.data.view,
                    loaded_invite: false,
                    selectedDivision: response?.data.view.divisions.length > 0 ? {label: response?.data.view.divisions[0].option, value: response?.data.view.divisions[0].value} : null, 
                    selectedVMH: response?.data.view.vmhs.length > 0 ? {label: response?.data.view.vmhs[0].option, value: response?.data.view.vmhs[0].value} : null, 
                    selectedOccupation: response?.data.view.occupations.length > 0 ? {label: response?.data.view.occupations[0].option, value: response?.data.view.occupations[0].value} : null,
                    selectedLanguage: response?.data.language ? response?.data.language : {label: "English", value: "English"}
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    loadDivisions(value) {
        axios.post('/ajax/stakeholder/' + value + '/options', {
                'filter': 'oem_with_booking',
            })
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.form_details.divisions = response?.data.stakeholders;

                if(newState.selectedDivision != null)
                {
                    newState.selectedDivision = {value: response?.data.stakeholders[0].value, label: response?.data.stakeholders[0].option};
                    newState.invite_form["invite_sh_id"] = response?.data.stakeholders[0].value;
                }

                if(newState.selectedVMH != null)
                {
                    newState.selectedVMH = "vmhs" in response?.data && response?.data.vmhs.length > 0 ? {value: response?.data.vmhs[0].value, label: response?.data.vmhs[0].option} : null;
                    newState.invite_form["invite_vmh_id"] = "vmhs" in response?.data && response?.data.vmhs.length > 0 ? response?.data.vmhs[0].value : null;
                }

                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    loadVMHs(value) {
        axios.post('/ajax/vmh/' + value + '/options', {
                'filter': 'oem_with_booking',
            })
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.form_details.vmhs = response?.data.vmhs;

                if(newState.selectedVMH != null)
                {
                    newState.selectedVMH = {value: response?.data.vmhs[0].value, label: response?.data.vmhs[0].option};
                    newState.invite_form["invite_vmh_id"] = response?.data.vmhs[0].value;
                }

                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    loadOccupations(value) {
        axios.get('/ajax/occupations/' + value + '/options')
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.form_details.occupations = response?.data;
                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    submitInvite(event) {
        event.preventDefault();
        var self = this;

        axios({
            method: 'post',
            url: '/ajax/invitation',
            data: this.state.invite_form,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then(function (response) {
            //handle success

            if(self.props.match.url.split("/")[1] === "useroverview") {
                axios({
                    method: 'post',
                    url: '/ajax/user_list/update',
                    data: {
                        search_term: $("#searchbar").val(),
                        vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        status: $("input[name='status[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        tier: $("input[name='tier[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        company: $("input[name='company[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        title: $("input[name='title[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        last_booking_min: $("#last_booking_min").text(),
                        last_booking_max: $("#last_booking_max").text(),
                        bookings_min: $("#bookings_min").text(),
                        bookings_max: $("#bookings_max").text(),
                        sort_filter: $("#sort_filter").val(),
                        sort_direction: $("#sort_direction").val(),
                    }
                })
                .then(function(response2) {
                    self.props.dispatch(setProfileDb(response2.data.data.data, self.props.data.profile_db));
                    self.props.dispatch(setList("SET_USER_LIST", response2.data.data.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            showStatusMsg(response?.data.message, 'success');
            if (self.props.closeModal) self.props.closeModal();
        })
        .catch(function (error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        });
    }

    getStarValue(value) {
        var invite_form = this.state.invite_form;
        invite_form["star"] = value;

        this.setState({
            invite_form: invite_form
        });
    }

    updateInviteForm(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var invite_form = this.state.invite_form;
        invite_form[name] = value;

        this.setState({
            invite_form: invite_form
        });
    }

    updateOEM(option) {
        var invite_form = this.state.invite_form;
        invite_form["invite_oem_id"] = option.value;

        this.setState({
            invite_form: invite_form,
            selectedOEM: option,
            selectedDivision: null,
            selectedVMH: null,
            selectedOccupation: null
        });

        this.loadDivisions(option.value);
    }

    updateDivision(option) {
        var invite_form = this.state.invite_form;
        invite_form["invite_sh_id"] = option.value;

        this.setState({
            invite_form: invite_form,
            selectedDivision: option
        });

        this.loadVMHs(option.value); 
        this.loadOccupations(option.value);
    }

    updateVMH(option) {
        var invite_form = this.state.invite_form;
        invite_form["invite_vmh_id"] = option.value;

        this.setState({
            invite_form: invite_form,
            selectedVMH: option
        });
    }

    updateOccupation(option) {
        var invite_form = this.state.invite_form;
        invite_form["invite_occupation_id"] = option.value;

        this.setState({
            invite_form: invite_form,
            selectedOccupation: option
        });
    }

    updateLanguage(option) {
        var invite_form = this.state.invite_form;
        invite_form["language"] = option.value

        this.setState({
            invite_form: invite_form,
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    render(props) {
        return (
            <div id = "inviteuser-overlay" className ="small-overlay">
                <div className = "card no-margin">
                    <div className = "card-divider">
                        <span className = "card-header-title">Invite User</span>
                        <button className="close-button"  onClick={this.props.closeModal} type='button'>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <div className = "card-divider">
                        {
                            !this.state.loaded_invite ?
                                <div className = "row collapse mb-16">
                                    {
                                        !this.state.loaded_invite && this.state.form_details.oem_id == -9 ?
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label>OEM <span className = "red-alert">*</span>
                                                    <div className = "form-95">
                                                        <Select 
                                                            options={
                                                                !this.state.loaded_invite ?
                                                                    this.state.form_details.oems.map((oem, i) =>
                                                                       ({
                                                                        label: oem.option, value: oem.value
                                                                       })
                                                                    )
                                                                :
                                                                ([{
                                                                    label:'N/A', value:''
                                                                }])
                                                            } 
                                                            onChange={this.updateOEM}
                                                            value={this.state.selectedOEM}
                                                            style={{width: "100%",height:'36px'}}
                                                            className="react_select_dropdown"
                                                            classNamePrefix="react_select"
                                                        />
                                                    </div>
                                                </label>
                                            </div>
                                        :
                                            null
                                    }
                                    {
                                        !this.state.loaded_invite ?
                                            <div className = "columns large-6 medium-6 small-12" >
                                                <label><Trans>Division/Fleet</Trans> <span className = "red-alert">*</span>
                                                    <div className = {this.state.form_details.oem_id == -9 ? "" : "form-95"}>
                                                        <Select 
                                                            options={
                                                                !this.state.loaded_invite ?
                                                                    this.state.form_details.divisions.map((division, i) =>
                                                                        ({
                                                                            label: division.option, value:division.value
                                                                        })
                                                                    )
                                                                :
                                                                ([{
                                                                    label:'N/A', value:''
                                                                }])
                                                            } 
                                                            onChange={this.updateDivision}
                                                            value={this.state.selectedDivision}
                                                            style={{width: "100%",height:'36px'}}
                                                            className="react_select_dropdown"
                                                            classNamePrefix="react_select"
                                                        />
                                                    </div>

                                                </label>
                                            </div>
                                        :
                                            null
                                    }
                                    {
                                        !this.state.loaded_invite && this.state.form_details.oem_id != -9 ?
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label><Trans>VC Location</Trans> <span className = "red-alert">*</span>
                                                    <div className = "form-95">
                                                        <Select 
                                                            options={
                                                                !this.state.loaded_invite ?
                                                                    this.state.form_details.vmhs.map((vmh, i) =>
                                                                    ({
                                                                        label: vmh.option,value: vmh.value
                                                                    })
                                                                    )
                                                                :
                                                                ([{
                                                                    label:'N/A', value:''
                                                                }])
                                                            } 
                                                            onChange={this.updateVMH}
                                                            value={this.state.selectedVMH}
                                                            style={{width: "100%",height:'36px'}}
                                                            className="react_select_dropdown"
                                                            classNamePrefix="react_select"
                                                        />
                                                    </div>
                                                </label>
                                            </div>
                                        :
                                            null
                                    }
                                </div>
                            :
                                null
                        }
                        <div className = "row collapse mb-16">
                            {
                                !this.state.loaded_invite && this.state.form_details.oem_id == -9?
                                    <div className = "columns large-6 medium-6 small-12">
                                        <label><Trans>VC Location</Trans> <span className = "red-alert">*</span>
                                            <div className = "form-95">
                                                <Select 
                                                    options={
                                                        !this.state.loaded_invite ?
                                                            this.state.form_details.vmhs.map((vmh, i) =>
                                                               ({
                                                                label: vmh.option,value: vmh.value
                                                               })
                                                            )
                                                        :
                                                        ([{
                                                            label:'N/A', value:''
                                                        }])
                                                    } 
                                                    onChange={this.updateVMH}
                                                    value={this.state.selectedVMH}
                                                    style={{width: "100%",height:'36px'}}
                                                    className="react_select_dropdown"
                                                    classNamePrefix="react_select"
                                                />
                                            </div>
                                        </label>
                                    </div>
                                :
                                    null
                            }
                            <div className = "columns large-6 medium-6 small-12" >
                                <label><Trans>User Role</Trans> <span className = "red-alert">*</span>
                                    <div className = {this.state.form_details.vmh_id == -9 ? "" : "form-95"}>
                                        <Select 
                                            options={
                                                !this.state.loaded_invite ?
                                                    this.state.form_details.occupations.map((occupation, i) =>
                                                    ({
                                                        label:occupation.option,value:occupation.value
                                                    })
                                                    )
                                                :
                                                ([{
                                                    label:'N/A', value:''
                                                }])
                                            } 
                                            onChange={this.updateOccupation}
                                            value={this.state.selectedOccupation}
                                            style={{width: "100%",height:'36px'}}
                                            className="react_select_dropdown"
                                            classNamePrefix="react_select"
                                        />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className = "card-section">
                        <div className = "row collapse">
                            <div className = "columns large-6 medium-6 small-12">
                                <label><Trans>First Name</Trans>
                                    <input type = "text" name = "first_name" className = "form-text form-95" onChange={this.updateInviteForm}/>
                                </label>
                            </div>
                            <div className = "columns large-6 medium-6 small-12">
                                <label><Trans>Last Name</Trans>
                                    <input type = "text" name = "last_name" className = "form-text" onChange={this.updateInviteForm}/>
                                </label>
                            </div>
                        </div>
                        <div className = "row collapse">
                            <div className = "columns large-6 medium-6 small-12">
                                <label><Trans>Email</Trans> <span className = "red-alert">*</span>
                                    <input type = "text" name = "email" className = "form-text form-95" onChange={this.updateInviteForm}/>
                                </label>
                            </div>
                            <div className = "columns large-6 medium-6 small-12">
                                <label><Trans>Language</Trans>
                                    <div className ="clearfix"></div>
                                        <div className = "form-95">
                                            <Select 
                                                options={
                                                    [{value: "English", label: "English", name: "language"}, {value: "French", label: "French", name: "language"}]
                                                } 
                                                onChange={this.updateLanguage}
                                                value={{value: this.state.invite_form.language, label: this.state.invite_form.language}}
                                                style={{width: "100%",height:'36px'}}
                                                className="react_select_dropdown"
                                                classNamePrefix="react_select"
                                            />
                                        </div>
                                </label>
                            </div>
                        </div>
                        <div className = "row collapse">
                            <div className = "columns large-6 medium-6 small-12">
                                <label><Trans>Tier</Trans>
                                    <div className ="clearfix"></div>
                                    <Stars star={this.state.invite_form.star} type={"Profile"} ID={1} updateForm={this.getStarValue} mutable />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className = "card-section">
                        <div className = "button-group float-right">
                            <a className = "button mr-8" onClick={this.props.closeModal}><Trans>Cancel</Trans></a>
                            <a className = "button primary" onClick={(event) => { this.submitInvite(event)}}><Trans>Invite</Trans></a>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(InviteOverlay)